<template lang="pug">
  #header
    v-container(grid-list-xs, text-xs-center)
      v-layout(row, wrap)
        v-flex.px-3(xs12 sm8)
          v-card.h-card.py-4(flat)
            p.text-sm-left.mb-0.heading AGRESIONES
            p.text-sm-left.mb-0.text Visualiza los incidentes documentados por la RRM en el mapa. Filtra por tipo de incidente y geografía, y descarga la información agregada.
        v-flex.download-data(xs12 sm4)
          v-btn.bold(href="https://s3.amazonaws.com/images.rompeelmiedo.org/Reportes.csv") Descargar datos
</template>

<script>
export default {
  name : "Header",
  props: {}
};
</script>

<style scoped lang="scss">
#header {
  background-color: #212a2e;
  font-family     : "Rajdhani", sans-serif;
  .h-card {
    background-color: #212a2e;
    color           : white;
    .heading {
      font-size  : 50px;
      font-weight: 700;
    }
    .text {
      font-size  : 25px;
      font-weight: 500;
    }
  }
  .download-data {
    display        : flex !important;
    justify-content: center !important;
    align-items    : center !important;
    .btn {
      border-radius   : 0px;
      background-color: #96a93f;
      font-family     : 'Rajdhani', sans-serif;
      color           : white;
      font-weight     : 700;
      font-size       : 20px;
      &:hover {
        background-color: #96a93f55;
        color           : #ffffff55;
      }
    }
  }
}
</style>
